import { Headers } from '@egw/components'
import { type FeatureFlags } from '@egw/constants'
import { useFlags } from '@egw/feature-flags'
import { WrappedLinkedAccountsPage as FeatureLinkedAccountsPage } from '@egw/features-external-accounts'
import { NotFound404 } from '@egw/features-system'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'

export const LinkedAccountsPage: FC = () => {
  const { t } = useTranslation('features-external-accounts')
  const { flags } = useFlags<FeatureFlags>()

  return (
    <Layout>
      <Headers title={t('accounts.linked_accounts')} />
      {flags.rolloutPlaidLinkedAccounts ? <FeatureLinkedAccountsPage /> : <NotFound404 />}
    </Layout>
  )
}

export default LinkedAccountsPage
